/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'WORKING_HOUR_RECORDS_FOR_EACH_WORKER_ARE_MAINTAINED_FOR_AT_LEAS',
              'WORKING_HOUR_RECORDS_FOR_EACH_WORKER_S_REGULAR_AND_OVERTIME_HOU',
              'START_AND_FINISH_TIMES_ARE_RECORDED_FOR_ALL_PERIODS_OF_WORK',
              'START_AND_FINISH_TIMES_IN_THE_PAYROLL_SYSTEM_MATCH_EXACT_TIME_I',
              'WORKING_HOUR_RECORDS_ARE_CONSISTENT_WITH_PAYROLL_AND_OTHER_RECO',
              'WORKERS_HAVE_UNRESTRICTED_ACCESS_TO_VERIFY_THE_ACCURACY_OF_WORK',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_follow_any_of_the_following_practices_regarding_wo: valueSchema,
  },
}
